import z from "zod";

export const maritalStatusEnum = z.enum([
  'single',
  'married',
  'divorced',
  'widowed',
]);